import { CrawlInProgressError } from "../../types/crawlerHealth";

const isCrawlInProgressError = (data: unknown): data is CrawlInProgressError =>
  typeof data === "object" &&
  data !== null &&
  (data as Partial<CrawlInProgressError>).error === "crawl_in_progress";

/**
 * Human-readable message for a failed manual crawler trigger — 2026-09-18 (KI-51(b), double-review
 * 51b-W2).
 *
 * The backend now answers 409 on every manual crawler-trigger route (`MediationCrawlerCard`'s
 * `crawl`/`reindex`, `SpmCrawlerCard`'s `onSubmit`, `AbstractCrawlerCard`'s `onSubmit`) with
 * `{"error": "crawl_in_progress", "target": "..."}` while any crawl — cron or manual — is already
 * running. Before this helper, callers did `message.error(error.message)`, which surfaced axios's
 * generic "Request failed with status code 409" on every Reindex click during a routine cron tick —
 * a regression an operator reads as a bug. This decodes that specific body into an actionable
 * message and falls back to the pre-existing generic idiom (`SystemHealthPage.handleTrigger`'s
 * `err?.response?.data?.error ?? err?.message`) for every other error shape, so it is safe to use
 * at any manual-trigger call site without changing behavior for unrelated failures.
 */
export const describeCrawlerError = (error: any): string => {
  const data = error?.response?.data;
  if (error?.response?.status === 409 && isCrawlInProgressError(data)) {
    return `A crawl is already running (target: ${data.target}) — see System Health.`;
  }
  return data?.error ?? error?.message ?? "Request failed";
};
